document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('.kh');
  if (!container) return;

  const tocList = container.querySelector('[data-kh-toc-list]');
  if (!tocList) return;

  // 1. 收集有标题的 section
  const entries = [];
  container.querySelectorAll('.kh-module').forEach((section, index) => {
    const h2 = section.querySelector('h2');
    if (!h2) return;
    if (!section.id) section.id = `kh-section-${index}`;
    entries.push({ id: section.id, text: h2.textContent.trim() });
  });

  // 2. 少于 2 个 section，隐藏 TOC 栏
  if (entries.length < 2) {
    const tocCol = container.querySelector('.kh-toc-col');
    if (tocCol) tocCol.hidden = true;
    return;
  }

  // 3. 生成 TOC（不拦截点击，让浏览器原生跳转）
  entries.forEach(({ id, text }) => {
    const li = document.createElement('li');
    const a = document.createElement('a');
    a.href = `#${id}`;
    a.textContent = text;
    li.appendChild(a);
    tocList.appendChild(li);
  });

  // 4. 滚动高亮（可选，不影响跳转）
  const links = tocList.querySelectorAll('a');
  let ticking = false;
  function updateActive() {
    let current = '';
    container.querySelectorAll('.kh-module').forEach((section) => {
      if (section.getBoundingClientRect().top < 150) current = section.id;
    });
    links.forEach((a) => {
      a.classList.toggle('active', a.getAttribute('href') === `#${current}`);
    });
    ticking = false;
  }
  window.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(updateActive);
      ticking = true;
    }
  }, { passive: true });
  updateActive();
});